import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const ssoBegun: CaseReducer<NinchatState> = (state) => state
